(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared-2/assets/javascripts/components/searchbar-section/searchbar-section.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared-2/assets/javascripts/components/searchbar-section/searchbar-section.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const Searchbar = svs.grassroots.components.searchbar_section.Searchbar;
const grassrootsQueryApi = svs.grassroots.store.grassrootsQueryApi;
const _React = React,
  useState = _React.useState,
  useRef = _React.useRef;
const links = svs.grassroots.links;
const _ReactRouterDOM = ReactRouterDOM,
  useHistory = _ReactRouterDOM.useHistory;
const SearchbarSection = _ref => {
  let openBottomSheet = _ref.openBottomSheet;
  const _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    displayResults = _useState2[0],
    setDisplayResults = _useState2[1];
  const _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    searchterm = _useState4[0],
    setSearchterm = _useState4[1];
  const _grassrootsQueryApi$u = grassrootsQueryApi.useFetchReceiversSearchQuery({
      searchterm
    }),
    data = _grassrootsQueryApi$u.data;
  const ref = useRef(null);
  const history = useHistory();

  const fetchReceiversHandler = e => {
    history.push(svs.grassroots.links.query(e.target[0].value));
  };
  const resetSearchField = () => {
    setDisplayResults(false);
    setSearchterm('');
  };
  const onBlurHandler = e => {
    if (!ref.current.contains(e === null || e === void 0 ? void 0 : e.relatedTarget)) {
      resetSearchField();
    }
  };
  const onChangeHandler = e => {
    setSearchterm(e.currentTarget.value);
    setDisplayResults(true);
  };
  const onClickHandler = receiver => {
    openReceiverDetails(receiver);
  };
  const onKeyDownHandler = (event, receiver) => {
    if (event.keyCode === svs.utils.keylistener.KEY_ENTER) {
      openReceiverDetails(receiver);
    }
  };
  const openReceiverDetails = receiver => {
    resetSearchField();
    openBottomSheet(receiver);
    window.history.replaceState(null, null, "".concat(svs.core.data.baseUrl).concat(links.single(receiver.id, receiver.shortname)));
  };
  return React.createElement("div", {
    className: "grassroots-searchbar-section"
  }, React.createElement(Searchbar, {
    displayResults: displayResults,
    onBlur: onBlurHandler,
    onChange: onChangeHandler,
    onClick: onClickHandler,
    onKeyDown: onKeyDownHandler,
    onSubmit: fetchReceiversHandler,
    ref: ref,
    searchResult: data === null || data === void 0 ? void 0 : data.receivers,
    searchterm: searchterm
  }));
};
svs.grassroots.components.searchbar_section.SearchbarSection = SearchbarSection;

 })(window);